<template>
    <div class="d-flex w-100">
        <div class="select">
            <div class="options" :class="{ 'block': isFieldNotNull() }">
                <div class="cpfOption" @click="select">CPF</div>
                <div class="cnpjOption" @click="select">CNPJ</div>
            </div>
        </div>
        <text-input class="cpfOrCnpjInput" name="info" label="" @changeValue="changeValue" :value="fieldValue" />
    </div>
</template>

<script>
/* eslint-disable */
export default {
    data() {
        return {
            isCpfSelected: true,
            fieldValue: undefined
        }
    },
    props: {
        cpfOrCnpj: {
            required: true,
            type: Object
        }
    },
    computed: {
        value() {
            const { cpf, cnpj } = this.cpfOrCnpj
            if (this.isFieldNotNull(cnpj)) {
                this.isCpfSelected = false
                return cnpj
            }
            this.isCpfSelected = true
            return cpf
        },
    },
    methods: {
        select() {
            const cpf = this.$el.querySelector(".cpfOption")
            const cnpjOption = this.$el.querySelector(".cnpjOption")
            if (this.isFieldNotNull()) return
            this.isCpfSelected = !this.isCpfSelected
            if (this.isCpfSelected) {
                cpf.style.color = "crimson"
                cnpjOption.style.color = "white"
            } else {
                cpf.style.color = "white"
                cnpjOption.style.color = "crimson"
            }

        },

        isFieldNotNull(field = this.fieldValue) {
            return field != undefined && field != ''
        },
        changeValue(newValue) {
            this.fieldValue = newValue
            if (this.isCpfSelected) this.$emit("changeCPF", newValue.replace(/\D/g, ""))
            else this.$emit("changeCNPJ", newValue.replace(/\D/g, ""))
        },
        maskField() {
            const element = this.$el.querySelector(".cpfOrCnpjInput")
            element.addEventListener("keyup", (e) => {
                if (this.isCpfSelected) {
                    var v = e.target.value.replace(/\D/g, "")
                    v = v.replace(/\D/g, "")
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
                    e.target.value = v;
                }
                else {
                    e.target.value = e.target.value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1 $2 $3/$4-$5");
                }
            })
        }
    },
    mounted() {
        this.fieldValue = this.value
        console.warn(this.isCpfSelected)
        this.maskField();
        const cpf = this.$el.querySelector(".cpfOption")
        const cnpjOption = this.$el.querySelector(".cnpjOption")
        if (this.isCpfSelected) {
            cpf.style.color = "crimson"
            cnpjOption.style.color = "white"
        } else {
            cpf.style.color = "white"
            cnpjOption.style.color = "crimson"
        }
    }
}
</script>

<style lang="scss" scoped>
.options {
    margin-right: 0.5rem;
    display: flex;
    border: 1px solid white;
    border-radius: 5px;

    &>* {
        width: 10rem;
        height: 3rem;
        padding: 0.5rem 1rem;
        background: #00000024;
        cursor: pointer;
    }

    .cpfOption {
        border-right: 1px solid white;
    }

    &.block>* {
        cursor: not-allowed;
        opacity: 0.5;
    }
}
</style>